export default __webpack_public_path__ + "static/media/aircraft-img.3b5018b7.png";